var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"review-status"},[(_vm.status==1)?[_vm._v(" تایید شده ")]:(_vm.status==2)?[_vm._v(" در انتظار ")]:[_vm._v(" تایید نشده ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }